import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IWarehouse } from 'safe'
import {
  WarehousesTypes,
  SET_WAREHOUSES,
  SET_WAREHOUSE,
  UPDATE_WAREHOUSE,
  DELETE_WAREHOUSE,
} from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setWarehouses = (warehouses: IWarehouse[]): WarehousesTypes => ({
  type: SET_WAREHOUSES,
  payload: warehouses,
})
const setWarehouse = (warehouse: IWarehouse): WarehousesTypes => ({
  type: SET_WAREHOUSE,
  payload: warehouse,
})
const editWarehouse = (warehouse: IWarehouse): WarehousesTypes => ({
  type: UPDATE_WAREHOUSE,
  payload: warehouse,
})
const deleteWarehouse = (warehouse: IWarehouse): WarehousesTypes => ({
  type: DELETE_WAREHOUSE,
  payload: warehouse,
})

export const fetchWarehouses =
  (): ThunkAction<Promise<void>, {}, {}, WarehousesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, WarehousesTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        warehouses: IWarehouse[]
      }> = await axios.get(`${server}/inventory/warehouse`)
      dispatch(setWarehouses(response?.data?.warehouses))
    } catch (e) {
      throw e
    }
  }

export const createWarehouse =
  (
    warehouse: Omit<IWarehouse, 'id'>
  ): ThunkAction<Promise<void>, {}, {}, WarehousesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, WarehousesTypes>): Promise<void> => {
    try {
      // warehouse.store = { id: '1' }
      const response: AxiosResponse<{
        status: number
        warehouse: IWarehouse
      }> = await axios.post(`${server}/inventory/warehouse`, warehouse)
      // @ts-ignore
      dispatch(setWarehouse({...response.data.warehouse, warehouseType: response.data.warehouse.warehouse_type, numberOfExistences: "0"}))
    } catch (e) {
      throw e
    }
  }

export const updateWarehouse =
  (
    warehouse: IWarehouse
  ): ThunkAction<Promise<void>, {}, {}, WarehousesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, WarehousesTypes>): Promise<void> => {
    try {
      // warehouse.store = { id: '1' }
      const response: AxiosResponse<{
        status: number
        updatedWarehouse: IWarehouse
      }> = await axios.patch(`${server}/inventory/warehouse`, {
        entity: { ...warehouse },
      })
      dispatch(editWarehouse(response.data.updatedWarehouse))
    } catch (e) {
      throw e
    }
  }

export const removeWarehouse =
  (
    warehouse: IWarehouse
  ): ThunkAction<Promise<void>, {}, {}, WarehousesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, WarehousesTypes>): Promise<void> => {
    try {
      // warehouse.store = { id: '1' }
      await axios.delete(`${server}/inventory/warehouse/${warehouse.id}`)
      dispatch(deleteWarehouse(warehouse))
    } catch (e) {
      throw e
    }
  }
